module.exports = __webpack_public_path__ + "static/media/assistant.55362488.webp";